export const BetslipMessageChannels = {
    CalculateBets: "CalculateBets",
    CalculateYourbetBets: "CalculateYourbetBets",
    PlaceBets: "PlaceBets",
    UpdatePurchases: "UpdatePurchases",
    GetPurchases: "GetPurchases"
};
//# sourceMappingURL=index.js.map